'use strict';

import {SETTINGS} from 'core/config/settings';

const angular = require('angular');

module.exports = angular
  .module('spinnaker.core.analytics.service', [
    require('angulartics'),
    require('angulartics-google-analytics'),
  ])
  .run(function ($window) {
    if (SETTINGS.analytics.ga) {
      $window.ga('create', SETTINGS.analytics.ga, 'auto');
    }
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/analytics/analytics.service.js